import React, { useContext } from 'react'
import { DownloadCSVButton } from '../../../components/common/download-csv-button/DownloadCSVButton'
import { IOverviewFilter } from './PathwaysOverviewTable'
import { PathwayEnrolmentsOverviewDocument } from './DownloadPathwaysCSV.codegen'
import { AnalyticsContext } from '../AnalyticsContext'
import { prepareCSVPathwaysExport } from './csv-pathways'

interface IDownloadPathwaysCSVProps {
  pathwaysOverviewFilter: IOverviewFilter
  pathwaysCount: number
}

export const DownloadPathwaysCSV = ({
  pathwaysOverviewFilter,
  pathwaysCount
}: IDownloadPathwaysCSVProps) => {
  const { filterAsQueryVariables } = useContext(AnalyticsContext)
  return (
    <DownloadCSVButton
      count={pathwaysCount}
      fileName={'looop-pathways'}
      dataPath={'data.analytics.pathways.enrolmentsOverview'}
      queryOptions={(page, limit) => ({
        variables: {
          mainAnalyticsFilter: filterAsQueryVariables,
          pathwaysOverviewFilter: {
            ...pathwaysOverviewFilter,
            page,
            limit
          }
        },
        query: PathwayEnrolmentsOverviewDocument
      })}
      prepareData={prepareCSVPathwaysExport}
    />
  )
}
